export default __webpack_public_path__ + "static/media/vi.5d0e6fe0.svg";